import {Controller} from "stimulus";

export default class extends Controller {
    static targets = ["error"]

    // Opens the shared task batch form for every task type selected, in a new tab -- the same
    // treatment the inspection control gives its Add button.
    buildTasks(event) {
        event.preventDefault()
        const select = this.element.querySelector("select.task-types")
        const selected = Array.from(select?.selectedOptions || []).filter(option => option.value !== "")
        if (selected.length === 0) {
            this.showError("Select at least one task type before adding.")
            return
        }
        const tasksPath = event.currentTarget.dataset.tasksPath
        if (!tasksPath) {
            this.showError("Unable to build task form link.")
            return
        }
        this.hideError()
        const taskSet = selected.map(option => option.value).join(",")
        window.open(`${tasksPath}?task_set=${encodeURIComponent(taskSet)}`, "_blank")
    }

    showError(message) {
        if (!this.hasErrorTarget) return
        this.errorTarget.textContent = message
        this.errorTarget.classList.remove("hidden")
    }

    hideError() {
        if (!this.hasErrorTarget) return
        this.errorTarget.textContent = ""
        this.errorTarget.classList.add("hidden")
    }
}
